import 'url-search-params-polyfill';
import PropTypes from 'prop-types';
import FileSaver from 'file-saver';
import Axios from 'axios'
import React, { Component } from 'react';
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Modal, message } from 'antd';
import { withRouter } from 'react-router-dom';
// import Axios from 'axios';
// import FileSaver from 'file-saver';

import {
  getRfqAndQuote,
  editQuote,
  handleQuoteSubmit,
  cancelQuote,
} from './graphql';
import history from '../../config/history';
import { tomcatHost, herokuProxyHost } from '../../config/properties';

export default function ContractQuoteHOC(ContractQuote) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.any.isRequired,
      location: PropTypes.object.isRequired,
    };

    static initialState = {
      initialValues: {
        id: '',
        comment: null,
        deliveryDate: '',
        ndaAccept: null,
        q_machiningReq: null,
        q_qty: null,
        q_sampleAvailable: null,
        q_toolingAvailable: null,
        q_toolingDesc: null,
        shipping: null,
        status: '',
        unitPrice: null,
      },
      ndaObj: {},
      rfqId: null,
      totalCost: 0,
      attachments: {},
      rfqDetails: [],
      rfqObject: {},
      showPdfModal: false,
      numPages: 0,
      pageNumber: 1,
      loading: false,
      rfqComment: null,
      readOnly: false,
      downloadingAttachment: false,
    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      this.setState({ loading: true });
      const urlParams = new URLSearchParams(this.props.location.search);
      console.log(urlParams);

      const rfqId = urlParams.get('rfq');
      const quoteId = urlParams.get('quote');

      const { id } = this.props.auth;
      if (rfqId && quoteId) {
        const res = await getRfqAndQuote(id, rfqId, quoteId);
        if (!res.rfqAndQuoteDetails) {
          message
            .error(
              'Oops, We Cannot Find this Quote, Please Contact Support if Problem Persists',
              2.5,
            )
            .then(() => {
              history.goBack();
            });
          return;
        }

        if (res.rfqAndQuoteDetails.unauthorized) {
          message
            .error(
              'Your Company does not have Permission to view this Quote',
              2.5,
            )
            .then(() => {
              history.goBack();
            });
          return;
        }

        const status = res.rfqAndQuoteDetails.quote.status;
        if (status !== 'Requested') {
          this.setState({ readOnly: true });
        }
        const formattedrfq = this.formatRFQ(res.rfqAndQuoteDetails.rfq);
        console.log(formattedrfq);
        this.setState({
          initialValues: res.rfqAndQuoteDetails.quote,
          rfqDetails: formattedrfq,
          rfqObject: res.rfqAndQuoteDetails.rfq,
          loading: false,
          rfqId,
        });
      } else {
        message
          .error(
            'Oops, We Cannot Find this Quote, Please Contact Support if Problem Persists',
            2.5,
          )
          .then(() => {
            history.goBack();
          });
      }
    }

    viewPDF = () => {
      this.setState(prevState => ({
        showPdfModal: !prevState.showPdfModal,
      }));
    };

    formatRFQ = rfq => {
      const formattedOBJ = {
        description: 'Description',
        solNum: 'Solicitation Number',
        niin: 'NIIN',
        partNum: 'Part Number',
        partDesc: 'Part Description',
        quoteDueDate: 'Quote Due Date',
        orderDueDate: 'Order Due Date',
        qty: 'Quantity',
        releaseQty: 'Release Quantity',
        castingWt: 'Casting Weight',
        toolingAvailable: 'Tooling Available',
        sampleAvailable: 'Sample Available',
        machiningReq: 'Machining Required',
        toolingDesc: 'Tooling Description',
        prefCastProc: 'Preferred Casting Process',
        secOpsReq: 'Secondary Operations Required',
        reqCastSpec: 'Required Casting Specifications',
        testingRqmts: 'Testing Requirements',
        rfqCreateDate: 'RFQ Create Date',
        r_material: 'Material',
        poc: 'Point of Contact',
        sampleDueDate: 'Sample Due Date',
        companyName: 'Company',
        phone: 'Phone',
        drawingNums: 'Drawing Numbers',
      };
      const formattedArray = [];
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(rfq)) {
        console.log(`${key}: ${value}`);
        if (formattedOBJ[key] || key === 'nda') {
          if (key !== 'nda') {
            const formattedKey = formattedOBJ[key];

            if (
              key === 'toolingAvailable' ||
              key === 'sampleAvailable' ||
              key === 'machiningReq' ||
              key === 'secOpsReq'
            ) {
              if (value === '1') {
                formattedArray.push({ key: formattedKey, value: 'Yes' });
              } else {
                formattedArray.push({ key: formattedKey, value: 'No' });
              }
            } else if (
              (key === 'qty' || key === 'castingWt' || key === 'releaseQty') &&
              value
            ) {
              formattedArray.push({
                key: formattedKey,
                value: value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
              });
            } else if (!value) {
              formattedArray.push({ key: formattedKey, value: '-' });
            } else {
              formattedArray.push({ key: formattedKey, value });
            }
          } else {
            const ndaName = Object.keys(rfq[key])[0];
            const display = Object.values(rfq[key])[0];

            this.setState({ ndaObj: { display, value: ndaName } });
          }
        } else {
          console.log('missing ', key);
          if (key === 'attachmentsList') {
            const attachments = value ? Object.assign({}, ...value) : null;
            this.setState({ attachments });
          }
          if (key === 'comment') {
            this.setState({ rfqComment: value });
          }
        }
      }
      return formattedArray;
    };

    _confirmQuoteSubmit = () => {
      Modal.confirm({
        title: 'Confirm Quote?',
        icon: <CheckCircleOutlined style={{ color: '#2ebd38' }} />,
        content:
          'This Will Submit the Quote and Notify the Sender of Your Decision',
        okText: 'Confirm',
        onOk: async () => {
          this._submitQuote();
        },
        onCancel: () => {
          console.log('test2');
        },

        cancelText: 'Cancel',
      });
    };

    changePage = offset =>
      this.setState(prevState => ({
        pageNumber: prevState.pageNumber + offset,
      }));

    previousPage = () => this.changePage(-1);
    nextPage = () => this.changePage(1);

    getParams = () => {
      const urlParams = new URLSearchParams(this.props.location.search);
      console.log(urlParams);

      const rfqId = urlParams.get('rfq');
      const quoteId = urlParams.get('quote');
      return { rfqId, quoteId };
    };

    _submitQuote = async () => {
      const { rfqId, quoteId } = this.getParams();
      const saveQuoteSuccess = await this._saveQuote();
      // figure out required fields and add errors check
      if (saveQuoteSuccess) {
        const res = await handleQuoteSubmit(this.props.auth.id, rfqId, quoteId);
        console.log(res);
        if (
          res.handleQuoteSubmit &&
          res.handleQuoteSubmit.status === 'success'
        ) {
          console.log('here');
          message.success('Successfully Submitted Quote', 2.5).then(() => {
            history.goBack();
          });
        } else {
          message.error(
            'Error Submitted Quote, Please Try again and if the Problem Persists Contact Support',
          );
        }
      }
    };

    _discardQuote = async () => {
      const urlParams = new URLSearchParams(this.props.location.search);
      console.log(urlParams);

      const rfqId = urlParams.get('rfq');
      const quoteId = urlParams.get('quote');

      const { id } = this.props.auth;
      if (rfqId && quoteId) {
        // TODO: make the call here to get the existing rfq
        // TODO: make it so they can't add recepients
        const res = await getRfqAndQuote(id, rfqId, quoteId);

        const formattedrfq = this.formatRFQ(res.rfqAndQuoteDetails.rfq);
        console.log(formattedrfq);
        this.setState({
          initialValues: res.rfqAndQuoteDetails.quote,
          rfqDetails: formattedrfq,
        });
      }
    };

    _saveQuote = async skipMessages => {
      const urlParams = new URLSearchParams(this.props.location.search);
      console.log(urlParams);

      const rfqId = urlParams.get('rfq');
      const quoteId = urlParams.get('quote');

      const data = { ...this.state.initialValues };
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(data)) {
        if (key.includes('q_')) {
          const formattedKey = key.split('_')[1];
          console.log(key, value);
          console.log(formattedKey);
          if (formattedKey === 'qty' && value) {
            data[formattedKey] = value.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '');
          } else {
            data[formattedKey] = value;
          }
          delete data[key];
        } else if (key === 'shipping' || key === 'unitPrice') {
          if (value) {
            data[key] = value.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '');
          }
        }
      }
      data.userId = this.props.auth.id;
      data.rfqId = rfqId;
      data.quoteId = quoteId;
      const res = await editQuote(data);
      if (res.updateQuote && res.updateQuote.status === 'success') {
        if (skipMessages) {
          message.success('Successfully Saved Quote');
        }
        return true;
      }
      message.error(
        'Oops, Something Went Wrong While Saving the Quote, Please Try Again and If Problem Persists Contact Support',
      );
      return false;
    };

    cancelQuote = async () => {
      const urlParams = new URLSearchParams(this.props.location.search);
      console.log(urlParams);

      const rfqId = urlParams.get('rfq');
      const quoteId = urlParams.get('quote');
      const res = await cancelQuote(this.props.auth.id, rfqId, quoteId);
      console.log(res);
      if (res.cancelQuote.status === 'success') {
        message.success('Succesfully Canceled Quote').then(() => {
          history.goBack();
        });
      } else {
        // error message something went wrong :shrug_guy:
        message.error(
          'Oops, Something Went Wrong, Please Try Again or Contact Support',
        );
      }
    };

    _confirmQuoteCancel = () => {
      Modal.confirm({
        title: 'Cancel Quote?',
        icon: <CloseCircleOutlined style={{ color: '#ff4d4f' }} />,
        content:
          'This will Cancel the Quote and Notify the sender of the decision',
        okText: 'Confirm',
        onOk: () => {
          this.cancelQuote();
        },
        onCancel: () => {
          console.log('test2');
        },

        cancelText: 'Cancel',
      });
    };
    _changeDate = (e, value) => {
      console.log('change date why arent you working? ');
      const initialValuesCopy = { ...this.state.initialValues };
      const { name } = e;
      console.log(e, value);
      initialValuesCopy[name] = value;
      this.setState({
        initialValues: initialValuesCopy,
      });
    };

    pick = (obj, keys) =>
      keys
        .map(k => (k in obj ? { [k]: obj[k] } : {}))
        .reduce((res, o) => Object.assign(res, o), {});

    calculateTotalCost = (unitPrice = '0', qty = '0', shipping = '0') => {
      const up = unitPrice.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '');
      const quantity = qty.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '');
      const ship = shipping.replace(/[&\/\\#,+()$~%'":*?<>{}]/g, '');

      const total = parseFloat(up) * parseFloat(quantity) + parseFloat(ship);
      return total.toFixed(2);
    };

    _handleFormSubmit = e => {
      const requiredFields = this.pick(e, ['unitPrice', 'q_qty', 'shipping']);

      const total = this.calculateTotalCost(
        requiredFields.unitPrice,
        requiredFields.q_qty,
        requiredFields.shipping,
      );

      this.setState({
        initialValues: e,
        totalCost: total,
      });
    };

    downloadNDA = async () => {
      try {
        const res = await Axios.get(
          `${herokuProxyHost}/${tomcatHost}/rfq/attachment/nda/${this.state.ndaObj.value}`,
          {
            responseType: 'blob',
            headers: {
              Authorization: `Bearer ${this.props.auth.jwtToken}`,
            }
          },
        );
        const data = res.data;
        const blob = new Blob([data], { type: 'octet/stream' });
        console.log(blob, 'nda');
        if (navigator.msSaveBlob) {
          // For IE
          console.log('here');
          navigator.msSaveBlob(blob, 'NDA.pdf')
        } else {
          FileSaver.saveAs(blob, 'NDA.pdf');
        }

      } catch (err) {
        console.log(err);
      }
    };

    onDocumentLoadSuccess = async ({ numPages }) => {
      if (this.state.numPages !== numPages) {
        this.setState({
          numPages,
        });
      }
    };

    _downloadAttachments = async (attachmentId, attachmentName) => {


      this.setState({ downloadingAttachment: true });
      await Axios.get(
        `${herokuProxyHost}/${tomcatHost}/rfq/attachment/${this.state.rfqId
        }/${attachmentId}`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${this.props.auth.jwtToken}`,
          }
        },
      ).then(res => {

        this.setState({ downloadingAttachment: false });
        const data = res.data;

        const blob = new Blob([data], { type: 'octet/stream' });
        console.log(blob, attachmentName);
        if (navigator.msSaveBlob) {
          // For IE
          navigator.msSaveBlob(blob, attachmentName)
        } else {
          FileSaver.saveAs(blob, attachmentName);

        }
      }).catch(error => {
        this.setState({ downloadingAttachment: false });
        console.log(error);
      });
    }



    // _downloadAttachments = async (attachmentId, attachmentName) => {

    //   try {
    //     const res = await Axios.get(
    //       `${herokuProxyHost}/${tomcatHost}/rfq/attachment/${this.state.rfqId
    //       }/${attachmentId}`,
    //       {
    //         responseType: 'blob',
    //         headers: {
    //           Authorization: `Bearer ${this.props.auth.jwtToken}`,
    //         }
    //       },
    //     );

    //     const data = res.data;

    //     const blob = new Blob([data], { type: 'octet/stream' });
    //     console.log(blob, attachmentName);
    //     if (navigator.msSaveBlob) {
    //       // For IE
    //       navigator.msSaveBlob(blob, attachmentName)
    //     } else {
    //       FileSaver.saveAs(blob, attachmentName);
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // };

    render() {
      const {
        initialValues,
        rfqDetails,
        ndaObj,
        showPdfModal,
        numPages,
        pageNumber,
        loading,
        readOnly,
        rfqObject,
        totalCost,
        attachments,
        rfqComment,
        downloadingAttachment,
      } = this.state;
      const pageProps = {
        auth: this.props.auth,
        initialValues,
        rfqComment,
        totalCost,
        readOnly,
        rfqObject,
        attachments,
        ndaObj,
        rfqDetails,
        changeDate: this._changeDate,
        handleFormSubmit: this._handleFormSubmit,
        confirmQuoteSubmit: this._confirmQuoteSubmit,
        confirmQuoteCancel: this._confirmQuoteCancel,
        saveQuote: this._saveQuote,
        showPdfModal,
        viewPDF: this.viewPDF,
        discardQuote: this._discardQuote,
        downloadNDA: this.downloadNDA,
        downloadAttachments: this._downloadAttachments,
        onDocumentLoadSuccess: this.onDocumentLoadSuccess,
        numPages,
        pageNumber,
        nextPage: this.nextPage,
        previousPage: this.previousPage,
        loading,
        downloadingAttachment,
      };
      return <ContractQuote {...pageProps} />;
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/contractQuote/ContractQuoteHOC.jsx